interface Event {
	date: string
	dateend: string
	datestart: string
	desc: string
	id: null
	link: string
	time: string
	title: string
	title2: string
	type: number
	typecourses: string
  }

class BaseEvent {
	event: Event
	element: undefined
	constructor(event: Event) {
		this.event = event;
		this.element = undefined;
		// console.log(event)
	}

	toElement() {
		return `<div style="color: #000">${this.event.title}<div>`;
	}

	listenToElement(callbac = undefined) {
		window.addEventListener(`bw-fc-event-mount-${this.event.id}`, (e: any) => {
			this.element = e.detail.element;

			// if (callbac) {
			// 	callbac();
			// }
		});
	}

	toFcEvent() {
		return {
			id: this.event.id,
			allDay: true,
			start: this.event.date,
			custom: { ...this.event },
			eventObj: this,
		};
	}

	// toListEvent() {
	// 	return `
    //     <span class="list-item-link ${this.event.marked ? 'highlight' : ''}" >
    //     <div class="list-row d-flex justify-content-between">
    //                     <a  href="${this.event.link
	// 		}" class="column-1 d-flex flex-column justify-content-center align-items-start">
    //                         ${this.event.for
	// 			.map(
	// 				(
	// 					label
	// 				) => `<div class="label-for mr-1 txt__iota lh__kappa spacing__gamma weight__bold">
    //                                 <span class="label-for__icon-box d-none">
    //                                     <img class="icon-box__icon" src="${label.icon}" alt="ikona" data-item="svg">
    //                                 </span>
    //                                 ${label.label}
    //                             </div>`
	// 			)
	// 			.join('')}
    //                         <span class="txt__gamma lh__gamma spacing__alfa weight__light">${this.event.title2
	// 		}</span>
                            
                              
    //                         <div class="d-flex d-lg-none flex-column justify-content-center mt-1">
    //                             <span class="txt__gamma lh__alfa spacing__alfa weight__light">${this.event.date
	// 		}</span>
    //                             <span class="txt__gamma lh__alfa spacing__alfa weight__light">${this.event.time
	// 		}</span>
    //                         </div>
    //                     </a>
    //                     <a  href="${this.event.link
	// 		}" class="column-2 d-none d-lg-flex flex-column justify-content-center align-items-center">
    //                         <span class="txt__gamma lh__alfa spacing__alfa weight__light">${this.event.date
	// 		}</span>
    //                         <span class="txt__gamma lh__alfa spacing__alfa weight__light">${this.event.time
	// 		}</span>
    //                     </a>
    //                     <div class="column-3 d-flex flex-column justify-content-center align-items-start">
    //                         <div class="div d-flex flex-wrap align-items-center flex-wrap">
    //                         ${this.event.cycle
	// 			? `<div class="column-3__name txt__zeta lh__alfa spacing__alfa weight__bold">
    //                                     ${this.event.cycle}
    //                                 </div>`
	// 			: ''
	// 		}
    //                           ${this.event.link_buy
	// 			? `<a href="${this.event.link_buy}" class="column-3__link txt__iota spacing__gamma weight__semi-bold lh__kappa color-gradient__alfa-reverse" title="kup cały cykl">kup cały cykl</a>`
	// 			: ''
	// 		}
    //                         </div>
    //                         <div class="column-3__desc txt__gamma lh__alfa spacing__alfa weight__light">
    //                             <p>
    //                                 ${this.event.desc}
    //                             </p>
    //                         </div>
    //                     </div>
                        
                        
                        
    //                 </div>
    //                 </span>
    //     `;
	// }
}

export class WeekEvent extends BaseEvent {
	event: any;
	constructor(event:any) {
		super(event);
	}

	toElement() {
		return `
            <span class="popup__item ${this.event.marked ? 'highlight' : ''}">
            
        <div class="event__places d-flex flex-wrap align-items-center">
					<span class="places__item txt__beta spacing__reset weight__bold color__alfa lh__gamma">
					${this.event.type == 0 ? `<h3>${this.event.title} - ${this.event.title2}</h3>` : `<h3>${this.event.title2}</h3>`}
					</span>
        
        </div>
        
            <div class="event__desc">${this.event.desc}</div>
            <div class="event__date event__info"><img src="assets/img/site/icons/icon-calendar.webp" class="icon"> Data kursu: ${this.event.datestart} - ${this.event.dateend}</div>
            <div class="event__time event__info"><img src="assets/img/site/icons/icon-clock.webp" class="icon"> Godziny: ${this.event.time}</div>
            <div class="event__type event__info"><img src="assets/img/site/icons/icon-people.webp" class="icon"> Rodzaj kursu: ${this.event.typecourses}</div>
			<a href="${this.event.link
			}" class="event__link"><span>${this.event.type == 0 ? `Zapisz się do szkoły Naturopatii` : `Zapisz się na panel`}</span><span class="arrow-wrapper"><span class="arrow"></span></span></a>
            </span>
            `;
	}
}

// export class WeekendEvent extends BaseEvent {
// 	constructor(event) {
// 		super(event);
// 	}

// 	toElement() {
// 		return `<span class="event__full w-100 ${this.event.marked ? 'highlight' : ''}">
//         <div class="event__labels">
            
//         </div>
//         <div class="event__places d-flex flex-wrap align-items-center">
// 					<span class="places__item txt__beta spacing__reset weight__bold color__alfa lh__gamma">${this.event.place} - ${this.event.time
// 			} ${this.event.day ? `Dzień ${this.event.day}` : ''}</span>
//         <a href="${this.event.link
// 			}" class="txt__beta lh__lambda color__alfa weight__bold spacing__alfa mr-1 pr-1 w-100 text-wrap">${this.event.title2 ? this.event.title2 : ''
// 			}</a>
//         <div class="align-items-center flex-wrap ${this.event.link_buy ? 'd-flex' : 'd-none'}">
//             <div class="txt__zeta lh__gamma color__alfa weight__bold spacing__alfa mr-2 places__cycle-name">
//                 ${this.event.cycle}
//             </div>
//             <a href="${this.event.link_buy
// 			}" title="Kup cały cykl" class="txt__iota lh__kappa spacing__gamma weight__semi-bold color-gradient__alfa-reverse my-1">KUP CAŁY CYKL</a>
//         </div>
//         ${this.event.link_buy ? `` : ''}
//         </div>
        
//             <a href="${this.event.link
// 			}" class="event__desc txt__beta spacing__alfa weight__regular lh__alfa color__alfa">${this.event.desc}</a>
//             <div class="event__labels">
         
//             </div>
//             </span>
//             `;
// 	}
// }
